// extracted by mini-css-extract-plugin
export default {"address_footer_big_container":"address-module--address_footer_big_container--zlaRq","address_footer_container":"address-module--address_footer_container--PiGOS"};